import { create, type StateCreator } from "zustand";
import { persist, createJSONStorage, devtools } from "zustand/middleware";

interface TempStore {
  formData?: Record<string, any>;
  setFormData: (data?: Record<string, any>) => void;
  draftData?: Record<string, Record<string | number, Record<string, any>>>;
  setDraftData: (
    data?: Record<string, Record<string | number, Record<string, any>>>
  ) => void;
  modalOpen?: boolean;
  setModalOpen: (open: boolean) => void;
  meta?: any;
  setMeta: (meta: any) => void;
  refreshCallback?(): void;
  setRefreshCallback: (callback: () => void) => void;
}

const initialMenusState = {} satisfies Partial<TempStore>;
const tempStoreCreator: StateCreator<TempStore> = (set) => ({
  ...initialMenusState,
  setDraftData: (data) => set({ draftData: data }),
  setFormData: (data) => set({ formData: data }),
  setModalOpen: (open) => set({ modalOpen: open }),
  setMeta: (meta) => set({ meta }),
  setRefreshCallback: (callback) => set({ refreshCallback: callback }),
});
export const useTempStore = create<TempStore>()(
  devtools(
    persist(tempStoreCreator, {
      name: "temp-storage",
      storage: createJSONStorage(() => sessionStorage),
    })
  )
);
